export default {
  loading: state => state.loading,
  order: state => state.order,
  orderShippingStatus: state => state.orderShippingStatus,
}
